const BOILERPLATE_SNIPPETS = [
  'Map',
  'Highlight this date',
  'Highlight all dates',
  'Link to this event',
  'Update this event',
  'If anything here is inaccurate',
  'Add to Calendar',
  'Google Calendar •',
  'Outlook.com •',
  'Yahoo Calendar •',
  'Download .ics',
];

const PROTECTED_TOKEN_RE = /(https?:\/\/\S+|www\.\S+|\S+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}|@[A-Za-z][\w.]*|\b[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*\.[a-z]{2,}\b)/g;

const URL_RE = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

function decodeBasicEntities(value) {
  return String(value || '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>');
}

function htmlToPlainText(html = '') {
  if (typeof html !== 'string' || !html) return '';

  const withLineBreaks = html
    .replace(/\r\n?/g, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(?:div|h[1-6]|li|p|tr)>/gi, '\n')
    .replace(/<(?:div|h[1-6]|li|p|tr)(?:\s[^>]*)?>/gi, '\n')
    .replace(/<[^>]+>/g, ' ');

  return decodeBasicEntities(withLineBreaks).replace(/\u00a0/g, ' ');
}

function splitGluedWords(text) {
  let previous;
  let result = text;
  do {
    previous = result;
    result = result
      .replace(/([.!?])([A-Z][a-z])/g, '$1 $2')
      .replace(/(\))([A-Z])/g, '$1 $2')
      .replace(/([a-z]{2,})([A-Z][a-z])/g, '$1 $2')
      .replace(/([A-Z]{2,})([A-Z][a-z])/g, '$1 $2');
  } while (result !== previous);
  return result;
}

function insertMissingSpaces(text) {
  const ungluedUrls = text.replace(
    /(https?:\/\/\S*?(?:\/|\d))(?=[A-Z][a-z])/g,
    '$1 '
  );

  return ungluedUrls
    .split(PROTECTED_TOKEN_RE)
    .map((part, index) => {
      if (!part || index % 2 === 1) return part;
      return splitGluedWords(part);
    })
    .join('');
}

function insertParagraphBreaks(text) {
  return text
    .replace(/[ \t]*•[ \t]*(?=\S)/g, '\n• ')
    .replace(/\)[ \t]+(?=[A-Z])/g, ')\n\n')
    .replace(/([.!?])[ \t]+(?=[A-Z][a-z]{3,}(?:\s+[A-Z][a-z]{3,})+\s*[&:(])/g, '$1\n\n')
    .replace(
      /([a-z0-9.!?])[ \t]+(About the [A-Z][a-zA-Z]+)[ \t]+(?=[A-Z])/g,
      '$1\n\n$2\n\n'
    )
    .replace(
      /(^|[a-z0-9.!?\n])[ \t]*(About ((?:[A-Z][a-zA-Z]+\s+)+?[A-Z][a-zA-Z]+))[ \t]+\3\b/gm,
      (match, prefix, heading, repeated) => {
        const lead = prefix === '\n' || prefix === '' ? prefix : `${prefix}\n\n`;
        return `${lead}${heading}\n\n${repeated}`;
      }
    );
}

function isBoilerplateLine(line) {
  return BOILERPLATE_SNIPPETS.some((snippet) => line.includes(snippet));
}

function normalizeParagraphs(text) {
  return text
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function descriptionLetters(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');
}

export function cleanDescription(description = '', options = {}) {
  if (typeof description !== 'string' || !description) return '';

  const withSpaces = insertMissingSpaces(htmlToPlainText(description));
  const withBreaks = options.paragraphs === false ? withSpaces : insertParagraphBreaks(withSpaces);
  const withoutBoilerplate = withBreaks
    .split('\n')
    .filter((line) => !isBoilerplateLine(line))
    .join('\n');

  return normalizeParagraphs(withoutBoilerplate);
}

export function descriptionToSegments(text = '') {
  if (!text) return [];

  const segments = [];
  let lastIndex = 0;
  const re = new RegExp(URL_RE.source, 'gi');
  let match;

  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, match.index) });
    }

    const raw = match[0];
    const display = raw.replace(/[.,;:!?]+$/g, '');
    const trailing = raw.slice(display.length);
    const href = /^https?:\/\//i.test(display) ? display : `https://${display}`;
    segments.push({ type: 'link', value: display, href });
    if (trailing) segments.push({ type: 'text', value: trailing });
    lastIndex = match.index + raw.length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }

  return segments.length ? segments : [{ type: 'text', value: text }];
}
